/*
 * Filename: d:\projects\AutoFiFront\src\Content\Car\CarSingleCarousel\CarSingleCarousel.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Thursday, February 2nd 2023, 2:23:33 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */

import { useEffect, useState } from "react";
import { PictureType } from "Content/Car/CarImgSlider/CarImgSliderProps.type";
import styles from "Content/Car/CarSingleCarousel/CarSingleCarousel.module.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "Content/Car/CarSingleCarousel/Caroussel.css";
import CarousselStyled from "Theme/Component/CarousselStyled";

function CarSingleCarousel (props: {themeColor:string ; pictureObjects: PictureType[]}) {
    var [myPics, setMyPics] = useState<JSX.Element[]>([
            <div className={styles.pictureDiv} key={Math.random()}>
                <img className={styles.picture} src={`/PH${props.themeColor}.svg`} alt={"No Picture to display"} />
            </div>
        ]);
    var [infinite, setInfinite] = useState(false);

    useEffect(() => {
        var tmpPics = [];
        for (let i = 0; i < props.pictureObjects.length; ++i)
            tmpPics.push( <div key={Math.random()} className={styles.pictureDiv}>
                            <img className={styles.picture} src={props.pictureObjects[i].URI} alt={props.pictureObjects[i].Name} />
                        </div>)
        if (props.pictureObjects.length > 0) {
            setMyPics(tmpPics);
            setInfinite(true);
        }
    }, [props.pictureObjects]);

    return(
        <CarousselStyled autoFocus={true} bgColor={props.themeColor} thumbWidth={100} showThumbs={infinite} showArrows={infinite} autoPlay={infinite} width={"100%"} infiniteLoop={infinite} selectedItem={infinite ? 0 : -1}>
            {myPics}
        </CarousselStyled>
    );
}

export default CarSingleCarousel;
